// Replace CVJson with your own json file or url
exports.CVJson = "https://raw.githubusercontent.com/sanghoon-jun/cv/master/cv.json"
